import { render, staticRenderFns } from "./scq-adress-detail.vue?vue&type=template&id=17aeaa62"
import script from "./scq-adress-detail.vue?vue&type=script&lang=js"
export * from "./scq-adress-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports